%reset-button {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

:host {
  --button-color: #ffffff;
  --button-color-disabled: #cbcbcb;
  --button-background: var(--primary-standard);
  --button-background-outline: transparent;
  --button-color-hover: #ffffff;
  --button-background-hover: var(--primary-hard);
  --button-border-radius: var(--border-radius-1, 0.1875rem) var(--border-radius-1, 0.1875rem) var(--border-radius-1, 0.1875rem) var(--border-radius-1, 0.1875rem);
  --button-padding: 1rem 1.25rem;

  display: flex;

  button {
    display: flex;
  }

  a {
    display: inline-flex;
    box-sizing: border-box;
  }

  button,
  a {
    @extend %reset-button;
    background-color: var(--jump-button-background, var(--button-background));
    border-radius: var(--button-border-radius);
    color: var(--jump-button-color, var(--button-color));
    position: relative;
    font-family: var(--ff-primary, 'Arial'), sans-serif;
    font-weight: var(--fw-700, 700);
    font-size: var(--fs-400, 1rem);
    // line-height: var(--lh-400, 1.3);
    line-height: 1.2;
    align-items: center;
    gap: var(--button-gap, 0.5rem);
    text-decoration: none;

    padding: var(--jump-button-padding, var(--button-padding));

    // TODO: gestire il focus con un outline
    &:hover {
      background-color: var(--jump-button-background-hover, var(--button-background-hover));
      color: var(--jump-button-color-hover, var(--button-color-hover));
    }

    &[data-variant='primary'] {
      --button-color: var(--neutral-white);
      --button-background: var(--primary-standard);
      --button-color-hover: var(--neutral-white);
      --button-background-hover: var(--primary-hard);
    }

    &[data-variant='secondary'] {
      --button-color: var(--neutral-white);
      --button-background: var(--secondary-standard);
      --button-color-hover: var(--neutral-white);
      --button-background-hover: var(--secondary-hard);
    }

    &[data-variant='neutral'] {
      --button-color: var(--neutral-white);
      --button-background: var(--neutral-grey-secondary);
      --button-color-hover: var(--neutral-white);
      --button-background-hover: var(--neutral-grey-primary);
    }

    &[data-variant='white'] {
      --button-color: var(--neutral-grey-primary);
      --button-background: var(--neutral-white);
      --button-color-hover: var(--neutral-grey-primary);
      --button-background-hover: var(--neutral-grey-background);
    }

    &[disabled] {
      --button-background: var(--button-color-disabled);
      --button-background-hover: var(--button-color-disabled);
      cursor: not-allowed;
    }

    &[data-pill] {
      border-radius: 100rem;
    }

    &[data-size='small'] {
      font-size: var(--fs-300, 0.875rem);
      --button-padding: 0.65rem 1rem;
    }

    &[data-size='medium'] {
      font-size: var(--fs-400, 1rem);
      --button-padding: 0.75rem 1.25rem;
    }

    &[data-size='large'] {
      font-size: var(--fs-500, 1.125rem);
      --button-padding: 1rem 1.5rem;
    }

    &[data-outline] {
      background-color: var(--jump-background-outline, var(--button-background-outline));
      border: 1px solid var(--jump-button-background, var(--button-background));
      color: var(--jump-button-background, var(--button-background));
      &:hover {
        background-color: var(--jump-button-background-hover, var(--button-background-hover));
        border: 1px solid var(--jump-button-background-hover, var(--button-background-hover));
        color: var(--jump-button-color-hover, var(--button-color-hover));
      }
    }

    &[data-text] {
      background-color: transparent;
      border: none;
      color: var(--jump-button-background, var(--button-background));
      padding: 0;
      &:hover {
        background-color: transparent;
        border: none;
        color: var(--jump-button-background-hover, var(--button-background-hover));
      }
    }

    &[data-only-icon] {
      --button-padding: 0.5rem;
    }

    &[data-only-icon][data-size='small'] {
      --button-padding: 0.5rem;
    }
    &[data-only-icon][data-size='medium'] {
      --button-padding: 0.875rem;
    }
    &[data-only-icon][data-size='large'] {
      --button-padding: 1rem;
    }

    &[data-full] {
      width: 100%;
      justify-content: center;
    }

    &.chat {
      --button-color: var(--neutral-white);
      --button-background: hsla(133, 54%, 58%, 1);
      --button-color-hover: var(--neutral-white);
      --button-background-hover: hsla(161, 63%, 31%, 1);
    }
  }
}
